import courseService from '../services/courseService';
import _ from 'lodash';
// import { CourseFilterData } from '../types/CourseFilterData';

const coursesList = () => (dispatch:any) => {   
    const success = (data: any)  =>
    ({ type: 'COURSE_LIST_SUCCESS', data });
    const failure = (error: string) =>
    ({ type: 'COURSE_LIST_FAILED', error });

    courseService.getAllCourses()
    .then(
      (res: any) => {
        if (res) {
            dispatch(success(res));
        }
        else{
            (err:any) => { dispatch(failure(err)) }
        }
      },
      
    );
}

const coursesActions = {
    coursesList,
  };

export default coursesActions